import { t } from '@lingui/core/macro';
export const normalizeItems = (data) => {
    const teams = (data === null || data === void 0 ? void 0 : data.teams) || [];
    const users = (data === null || data === void 0 ? void 0 : data.companyUsers) || [];
    const isValidUser = (user) => { var _a; return Boolean((_a = user.user) === null || _a === void 0 ? void 0 : _a.id); };
    const isValidTeamMember = (member) => { var _a; return Boolean((_a = member.user) === null || _a === void 0 ? void 0 : _a.id); };
    const userNameFallback = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    const normalizedTeams = teams.map((team) => {
        var _a;
        return ({
            type: 'team',
            id: team.id,
            name: team.name,
            members: ((_a = team.members) === null || _a === void 0 ? void 0 : _a.filter(isValidTeamMember).map((member) => {
                var _a, _b, _c, _d;
                return ({
                    userId: member.user.id,
                    name: (_b = (_a = member.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : userNameFallback,
                    email: (_d = (_c = member.user) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '',
                });
            })) || [],
        });
    });
    const normalizedUsers = users.filter(isValidUser).map((user) => {
        var _a, _b, _c;
        return ({
            type: 'user',
            id: user.user.id,
            name: (_a = user.user.name) !== null && _a !== void 0 ? _a : userNameFallback,
            email: (_c = (_b = user.user) === null || _b === void 0 ? void 0 : _b.email) !== null && _c !== void 0 ? _c : '',
        });
    });
    const sortedTeams = normalizedTeams.sort((a, b) => a.name.localeCompare(b.name));
    const sortedUsers = normalizedUsers.sort((a, b) => a.name.localeCompare(b.name));
    return { teams: sortedTeams, users: sortedUsers };
};
